import * as React from 'react';
import './Box.less';
import bindAllOfThis from "src/utils/BindThisHelper";
import { Grade } from "src/constants/Grades";
import { Planet } from "src/constants/Planets";
import { Translate } from 'react-localize-redux';
import { Row, Col } from "antd";

interface DialogBoxProps {
    currentPlanet: Planet;
    currentGrade: Grade;
    onNext?: () => void;
    onBack?: () => void;
    buttonNextType?: "arrow" | "standard" | "none";
    buttonBackType?: "arrow" | "none";
    buttonTextKey?: string;
}

class DialogBox extends React.Component<DialogBoxProps> {
    constructor(props: DialogBoxProps) {
        super(props);
        bindAllOfThis(this, DialogBox.prototype);
    }

    isNextButton(): boolean {
        return this.props.onNext != null && (this.props.buttonNextType == null || this.props.buttonNextType === "arrow");
    }

    isTraditionalButton(): boolean {
        return this.props.onNext != null && this.props.buttonTextKey != null && this.props.buttonTextKey.length > 0 && this.props.buttonNextType === "standard";
    }

    isBackButton(): boolean {
        return this.props.onBack != null && (this.props.buttonBackType == null || this.props.buttonBackType === "arrow");
    }

    /**
     * Simple next button (arrow)
     */
    renderNextButton() {
        if (!this.isNextButton()) {
            return null;
        }
        return <button autoFocus tabIndex={1} className="ant-btn next-button" onClick={this.props.onNext} title="next">
            <span><Translate id="common.next" /></span>
            <div className="button-container">
                <svg width="16" height="11" viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg"><path d="M16 5.333L10 0v4H0v2.667h10v4z" fill="#FFF" fillRule="nonzero" /></svg>
            </div>
        </button>;
    }

    renderBackButton() {
        if (!this.isBackButton()) {
            return null;
        }   
        return <button tabIndex={1} className="ant-btn back-button" onClick={this.props.onBack} title="back">
            <div className="button-container">
                <svg width="16" height="11" viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg"><path transform="rotate(180 8, 5.333)" d="M16 5.333L10 0v4H0v2.667h10v4z" fill="#FFF" fillRule="nonzero" /></svg>
            </div>
            <span><Translate id="common.back" /></span>
        </button>;
    }

    /**
     * Traditional button with some text
     */
    renderTraditionalButton() {
        if (!this.isTraditionalButton()) {
            return null;
        }

        return <div style={{ textAlign: 'center' }}>
            <button autoFocus tabIndex={1} id="button" className="ant-btn ant-btn-lg ant-btn-primary" onClick={this.props.onNext}>
                <Translate id={this.props.buttonTextKey} />
            </button>
        </div>;
    }

    render() {
        let className = `box-component planet-${(this.props.currentPlanet || { name: "" }).name}`.toLowerCase();
        return <div id="dialogBox" className={className}>
            {this.props.children}
            <Row type="flex" justify="space-between">
                <Col span={6}>
                    {this.renderBackButton()}
                </Col>
                <Col span={6} className="super-button">
                    {this.renderNextButton()}
                </Col>
                <Col span={24}>
                    {this.renderTraditionalButton()}
                </Col>
            </Row>
        </div>;
    }
}

export default DialogBox;



// WEBPACK FOOTER //
// ./src/components/mission/DialogBox.tsx